export default {
  loginout: 'Đăng xuất',
  logout: 'Đăng xuất',
  login: 'đăng nhập',

  changepasswd: 'change the password',
  changeLanguage: 'change language',
  safeCenter: 'Security center'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/home.js